<template>
  <nav class="navbar">
    <div class="logo">
      <router-link to="/">Journal App</router-link>
    </div>
    <ul class="nav-links">
      <li><router-link to="/journal">Journal</router-link></li>
      <li><router-link to="/archive">Archive</router-link></li>
      <li><router-link to="/account">Account</router-link></li>
      <li><button @click="logout">Logout</button></li>
      <!-- Profile picture -->
      <li v-if="userPhotoUrl">
        <img :src="userPhotoUrl" alt="Profile Photo" class="profile-photo">
      </li>
    </ul>
  </nav>
</template>

<script>
import { getAuth, signOut, onAuthStateChanged } from 'firebase/auth';

export default {
  data() {
    return {
      userPhotoUrl: null
    };
  },
  created() {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user && user.photoURL) {
        this.userPhotoUrl = user.photoURL; // Update user photo URL from authenticated user data
      }
    });
  },
  methods: {
    logout() {
      const auth = getAuth();
      signOut(auth).then(() => {
        this.$router.push('/login');
      }).catch((error) => {
        console.error('Logout Failed:', error);
      });
    }
  }
}
</script>

<style scoped>
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: #333;
  color: #fff;
}

.logo a {
  color: #fff;
  text-decoration: none;
  font-weight: bold;
}

.nav-links {
  list-style: none;
  display: flex;
  align-items: center; /* Align items vertically */
}

.nav-links li {
  padding: 0 10px;
}

.nav-links a, .nav-links button {
  color: #fff;
  text-decoration: none;
  background: none;
  border: none;
  cursor: pointer;
}

.nav-links a:hover {
  text-decoration: underline;
}

.profile-photo {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
}
</style>
